import SlickCarousel from 'react-slick';
import styled from 'styled-components';
import '../../tier-options-v2/SlickCarousel.css';
import { BanksyImage } from '@stashinvest/ui';

export const StyledCarousel = styled(SlickCarousel)`
	.slick-slide div {
		outline: none !important;
	}
`;

export const Dots = styled.ul`
	display: flex;
	margin: 0 10px;
	li {
		display: flex !important;
		align-items: center;
		margin: 0 10px;
		button {
			font-size: 0;
			height: 10px;
			width: 10px;
			border-radius: 10px;
			background-color: ${({ theme }) => theme.colors.bgActionSecondary};
			padding: 0;
		}
		&.active {
			button {
				background-color: ${({ theme }) => theme.colors.textPrimary};
			}
		}
	}
`;

export const ArrowButton = styled.button`
	background-color: transparent;
	align-items: center;
	padding: 0;
	display: none;
	${({ theme }) => theme.mediaQueries.tablet} {
		display: flex;
	}
	&[disabled] {
		opacity: 0.2;
	}
`;

export const BanksyImageMobile = styled(BanksyImage).attrs({
	display: { mobile: 'block', tablet: 'none' },
	width: '100%',
	maxWidth: '280px',
	mb: 's',
})``;

export const BanksyImageDesktop = styled(BanksyImage).attrs({
	display: { mobile: 'none', tablet: 'block' },
	width: '100%',
	mb: 's',
})``;
